<template>
  <div>
    <v-edit-dialog
        v-if="!!labels"
        @save="$emit('click')"
        :save-text="labels.confirm"
        :cancel-text="labels.cancel"
        large
    >
      <v-btn small :disabled="disabledBtn" :loading="loading">{{labels.btn}}</v-btn>
      <template v-slot:input>
        <v-sheet class="mt-5">
          {{labels.text}}
        </v-sheet>
      </template>
    </v-edit-dialog>
  </div>
</template>

<script>

export default {
  name: 'BaseConfirmBtn',
  inheritAttrs: false,
  props: {
    labels: {default: null},
    loading: {type:[Boolean], default: false},
    disabled: {default: false},
  //   {
  //       btn: 'Action',
  //       confirm: 'Agree',
  //       cancel: 'Cancel',
  //       text: 'Are you sure?',
  //     }
  },

  components: {},

  computed: {},

  watch: {
    disabled: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        this.disabledBtn = newValue
      },
      deep: false
    },
  },

  methods: {
  },

  async mounted() {
    // this.deleted = this.value
  },

  data() {
    return {
      disabledBtn: this.disabled,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "are_you_sure": "Are you sure?",
    "cancel": "Cancel",
    "restore": "Restore",
    "delete": "Delete",
    "delete_message": "Do you want to delete? Are you sure?",
    "restore_message": "Do you want to restore? Are you sure?"
  },
  "de": {
    "are_you_sure": "Bist du sicher?",
    "cancel": "Stornieren",
    "restore": "Wiederherstellen",
    "delete": "löschen",
    "delete_message": "Möchten Sie löschen? Bist du dir sicher?",
    "restore_message": "Möchten Sie wiederherstellen? Bist du dir sicher?"
  }
}
</i18n>
